import React, { useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import FundInvestmentsTable from '../../components/Table/FundInvestmentsTable';
import { Link,Outlet,useNavigate, useLocation } from 'react-router-dom';

const FundInvestments = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const[ButData,setButData]=useState({
     SDL:"" ,
     Instrumente:"",
     TimeModus:"",
     Market:"",
     Time:""
})
const handleChange = (event) => {
     setButData({...ButData,[event.target.name]: event.target.value,});
};
    
  return (
    <>
     <div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>Fund Investments</span>
    </div>
     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                            <div style={{width:"98%",marginTop:40}}>
                                <FundInvestmentsTable />
                            </div>
            </div>
</div>
</>
  )
}

export default FundInvestments